import PageContainer from "@/components/layout/page-container";
import { EditOpportunityForm } from "@/modules/opportunities/edit-opportunities-form";

const EditOpportunities = () => {
  return (
    <PageContainer scrollable={true}>
      <div className="max-w-4xl rounded bg-white p-6">
        <div className="space-y-6">
          <EditOpportunityForm />
        </div>
      </div>
    </PageContainer>
  );
};

export default EditOpportunities;
